import { motion } from "framer-motion";
import * as Icons from "lucide-react";
import { WHY_CHOOSE } from "@/lib/data";

export default function WhyChoose() {
  return (
    <section id="why" data-testid="why-section" className="py-24 md:py-32 relative">
      <div className="max-w-7xl mx-auto px-6 md:px-8">
        <div className="max-w-2xl">
          <div className="text-xs tracking-[0.25em] uppercase text-[#D4AF37] font-bold mb-4">Why Choose Us</div>
          <h2 className="text-4xl sm:text-5xl font-light tracking-tighter">
            The <span className="font-serif italic text-gradient-royal">Globe Vista</span> advantage.
          </h2>
          <p className="mt-4 text-muted-foreground text-lg">
            Eight reasons why 1000+ students trust us with their global journey — from Santosh Nagar to Stanford.
          </p>
        </div>

        <div className="mt-14 grid sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {WHY_CHOOSE.map((item, i) => {
            const Icon = Icons[item.icon] || Icons.Sparkles;
            return (
              <motion.div
                key={item.title}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-50px" }}
                transition={{ duration: 0.5, delay: i * 0.05 }}
                data-testid={`why-card-${i}`}
                className="group relative p-6 rounded-2xl bg-card border border-border hover:border-[#D4AF37]/60 hover:-translate-y-1 hover:shadow-2xl hover:shadow-[#0F3D8C]/10 transition-all duration-500"
              >
                <div className="w-12 h-12 rounded-xl bg-[#0F3D8C]/10 dark:bg-[#2563EB]/15 flex items-center justify-center text-[#0F3D8C] dark:text-[#60A5FA] group-hover:bg-[#D4AF37] group-hover:text-white transition-colors">
                  <Icon className="w-6 h-6" strokeWidth={1.6} />
                </div>
                <h3 className="mt-5 font-heading font-semibold text-lg">{item.title}</h3>
                <p className="mt-2 text-sm text-muted-foreground leading-relaxed">{item.desc}</p>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
